module.exports = __webpack_public_path__ + "static/img/thumbnail.6c461ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191014/thumbnail.jpg
// module id = plHl
// module chunks = 1